import { isObject } from './object-guards.functions';
import { equal } from '../equal/equal';

// Source: https://github.com/mattphillips/deep-object-diff/
const isDate = (d: unknown): d is Date => d instanceof Date;
const isEmpty = (o: object): boolean => Object.keys(o).length === 0;
const properObject = (o: any): Record<number | string | symbol, unknown> =>
  isObject(o) && !o.hasOwnProperty ? { ...o } : o;

// oxlint-disable-next-line max-lines-per-function, max-statements
export const updatedDiff = <
  L extends Record<number | string | symbol, unknown>,
  R extends Record<number | string | symbol, unknown>,
>(
  lhs: L,
  rhs: R,
  updated?: true,
): Record<number | string | symbol, unknown> => {
  if (
    (lhs as Record<number | string | symbol, unknown>) ===
    (rhs as Record<number | string | symbol, unknown>)
  ) {
    return {};
  }

  if (!isObject(lhs) || !isObject(rhs)) {
    return rhs;
  }

  const l = properObject(lhs);
  const r = properObject(rhs);

  if (isDate(l) || isDate(r)) {
    // oxlint-disable-next-line eqeqeq
    if (l.valueOf() == r.valueOf()) {
      return {};
    }

    return r;
  }

  const returnObject: Record<number | string | symbol, unknown> = {};
  for (const key of Object.keys(r)) {
    if (updated && !(key in l)) {
      continue;
    }

    const difference = updatedDiff(
      l[key] as Record<number | string | symbol, unknown>,
      r[key] as Record<number | string | symbol, unknown>,
    );

    if (
      (isObject(difference) && isEmpty(difference) && !isDate(difference)) ||
      (Array.isArray(l[key]) &&
        Array.isArray(r[key]) &&
        (l[key] as Array<unknown>).length === 0 &&
        (r[key] as Array<unknown>).length === 0) ||
      equal(l[key], r[key])
    ) {
      continue;
    }

    returnObject[key] = difference;
  }

  return returnObject;
};
